"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusBox = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Colors_1 = require("../../../../Colors");
const common_1 = require("../../../../common");
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const StatusBoxStyled = styled_components_1.default.div `
	display: flex;
	flex-direction: row;
	gap: 32px;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	position: relative;
	width: 100%;

	.status {
		${({ $isMobile }) => $isMobile
    ? `
			border-radius: 10px;
			display: flex;
			flex-direction: row;
			gap: 24px;
			align-items: center;
			justify-content: center;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;
		`
    : `
		display: flex;
		flex-direction: row;
		gap: 32px;
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;`}
	}

	.info {
		display: flex;
		flex-direction: column;
		gap: 12px;
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		.round {
			display: flex;
			flex-direction: row;
			align-items: flex-start;
			justify-content: space-between;
			flex-shrink: 0;
			width: 90px;
			position: relative;

			.label2 {
				text-align: left;
				font-family: 'Noto Sans KR', sans-serif;
				font-size: 14px;
				line-height: 150%;
				letter-spacing: -0.02em;
				font-weight: 400;
				position: relative;
				display: flex;
				align-items: center;
				justify-content: flex-start;
			}

			.value2 {
				text-align: right;
				font-family: 'Noto Sans KR', sans-serif;
				font-size: 14px;
				line-height: 150%;
				letter-spacing: -0.02em;
				font-weight: 400;
				position: relative;
				flex: 1;
				display: flex;
				align-items: center;
				justify-content: flex-end;
			}
		}
	}

	.status-panel {
		border-radius: 8px;
		padding: 20px 0px 20px 0px;
		display: flex;
		flex-direction: row;
		gap: 20px;
		align-items: center;
		justify-content: center;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;

		.entire {
			display: flex;
			flex-direction: column;
			gap: 4px;
			align-items: center;
			justify-content: center;
			flex-shrink: 0;
			width: 140px;
			position: relative;
		}

		.label2 {
			color: var(--color-grey, #666666);
			text-align: center;
			font-family: var(--b1-font-family, 'Noto Sans KR', sans-serif);
			font-size: ${props => props.$isMobile || props.$isTablet
    ? 'var(--b3-font-size, 16px)'
    : 'var(--b1-font-size, 20px)'};
			line-height: ${props => props.$isMobile || props.$isTablet
    ? 'var(--b3-line-height, 32px)'
    : 'var(--b1-line-height, 42px)'};
			letter-spacing: var(--b1-letter-spacing, -0.02em);
			font-weight: var(--b1-font-weight, 400);
			position: relative;
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
		}
		.value2 {
			color: var(--color-black, #101010);
			text-align: center;
			font-family: var(--h2-font-family, 'Noto Sans KR', sans-serif);
			font-size: ${props => props.$isMobile || props.$isTablet
    ? 'var(--h4-font-size, 20px)'
    : 'var(--h2-font-size, 32px)'};
			line-height: ${props => props.$isMobile || props.$isTablet
    ? 'var(--h4-line-height, 32px)'
    : 'var(--h2-line-height, 46px)'};
			letter-spacing: var(--h2-letter-spacing, -0.02em);
			font-weight: var(--h2-font-weight, 700);
			position: relative;
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
		}

		.divider {
			background: #d9d9d9;
			align-self: stretch;
			flex-shrink: 0;
			width: 1px;
			position: relative;
			height: 100%;
		}
	}
`;
exports.StatusBox = react_1.default.memo(({ title, color, percentage, totalCount, done, noData, }) => {
    const { isMobile, isTablet, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const renderDoughnutChart = (0, react_1.useMemo)(() => {
        return (react_1.default.createElement(common_1.DoughnutChart, { percentage: noData ? '-' : percentage, size: isMobile ? 112 : isTablet ? 120 : 156, fontSize: !isDesktop && 20, fill: color, isHome: false }));
    }, [percentage, noData, color]);
    if (isMobile) {
        return (react_1.default.createElement(StatusBoxStyled, { "$isMobile": isMobile, "$isTablet": isTablet, "$isDesktop": isDesktop },
            react_1.default.createElement("div", { className: "status" },
                renderDoughnutChart,
                react_1.default.createElement("div", { className: "info" },
                    react_1.default.createElement("div", { className: "round" },
                        react_1.default.createElement("div", { className: "label2" }, "\uCD1D \uD68C\uCC28"),
                        react_1.default.createElement("div", { className: "value2" },
                            noData ? '-' : `${totalCount}회`,
                            " ")),
                    react_1.default.createElement("div", { className: "round", style: { color: Colors_1.Colors.p_ture } },
                        react_1.default.createElement("div", { className: "label2" }, title === 'replay'
                            ? '시청'
                            : title === 'attend'
                                ? '출석'
                                : '응시'),
                        react_1.default.createElement("div", { className: "value2" },
                            noData ? '-' : `${done}회`,
                            " ")),
                    react_1.default.createElement("div", { className: "round", style: { color: Colors_1.Colors.accent } },
                        react_1.default.createElement("div", { className: "label2" }, title === 'replay'
                            ? '미시청'
                            : title === 'attend'
                                ? '미출석'
                                : '미응시'),
                        react_1.default.createElement("div", { className: "value2" }, noData ? '-' : `${totalCount - done}회`))))));
    }
    return (react_1.default.createElement(StatusBoxStyled, { "$isMobile": isMobile, "$isTablet": isTablet, "$isDesktop": isDesktop },
        react_1.default.createElement("div", { className: "status" }, renderDoughnutChart),
        react_1.default.createElement("div", { className: "status-panel" },
            react_1.default.createElement("div", { className: "entire" },
                react_1.default.createElement("div", { className: "label2" }, "\uCD1D \uD68C\uCC28"),
                react_1.default.createElement("div", { className: "value2" },
                    noData ? '-' : `${totalCount}회`,
                    " ")),
            react_1.default.createElement("div", { className: "divider" }),
            react_1.default.createElement("div", { className: "entire" },
                react_1.default.createElement("div", { className: "label2" }, title === 'replay' ? '시청' : title === 'attend' ? '출석' : '응시'),
                react_1.default.createElement("div", { className: "value2" },
                    noData ? '-' : `${done}회`,
                    " ")),
            react_1.default.createElement("div", { className: "divider" }),
            react_1.default.createElement("div", { className: "entire" },
                react_1.default.createElement("div", { className: "label2" }, title === 'replay'
                    ? '미시청'
                    : title === 'attend'
                        ? '미출석'
                        : '미응시'),
                react_1.default.createElement("div", { className: "value2" }, noData ? '-' : `${totalCount - done}회`)))));
});
